/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-document-add': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.063 5.813l-4.375-4.375a.569.569 0 00-.438-.188H5c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.25a.569.569 0 00-.188-.438zM11.25 2.75l3.5 3.5h-3.5v-3.5zM15 17.5H5v-15h5v3.75c0 .69.56 1.25 1.25 1.25H15v10zm-1.875-5.625h-2.5v-2.5h-1.25v2.5h-2.5v1.25h2.5v2.5h1.25v-2.5h2.5v-1.25z"/>'
  }
})
